import { render } from "./invoice-setting.vue?vue&type=template&id=8eede85e"
import script from "./invoice-setting.vue?vue&type=script&lang=js"
export * from "./invoice-setting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__